import { useBranding } from '@/contexts/shared/BrandingContext';
import type { UiTheme } from '@/types/tenant.types';

/** The admin-selected interface theme: 'bento' (new) or 'classic'. */
export const useUiTheme = (): UiTheme => useBranding().uiTheme;
